module.exports = __webpack_public_path__ + "static/media/tram.cf21789c.svg";